import { client } from "helper/apolloConfig";
import { globalVariables } from "helper/globalVariables";
import { deleteIcon, uploadCloud } from "helper/icons";
import { useRef, useState } from "react";
import { useUpdateImageMutation } from "redux/features/api/apiSlice";
import { DeleteImageMutation } from "redux/features/superAdminSlice/manageGallery";
import Loader from "shared/Components/loader";
import { OutlineButton } from "shared/Components/outlineButton";
import { PopUpMessages } from "shared/Components/popUpMessages";

export const MobileGalleryComponent = ({ data, index, callBack }) => {
  const [updateImage, { isLoading: updateImageLoading }] =
    useUpdateImageMutation();
  const [isLoading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const modalRef = useRef();
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });

  const { imageName, imageKey } = data;
  const onDelete = async (imageKey) => {
    setLoading(true);
    const result = await client.mutate({
      mutation: DeleteImageMutation,
      variables: { imageKey: imageKey },
    });
    if (result.data) {
      callBack();
    }
  };
  const onCloseModal = () => {};

  const handleFileChange = (e) => {
    console.log("File size not accepted outside");
    if (e.target.files?.length) {
      console.log("File size not accepted inside");

      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (e.target.files[0].size <= maxSize) {
        console.log("File size not accepted if block");

        const formdata = new FormData();
        formdata.append("image", e.target.files[0]);
        formdata.append("imageKey", imageKey);
        updateImage(formdata).then(() => {
          callBack();
        });
      } else {
        console.log("File size not accepted");
        setApiData({
          title: 'Warning',
          desc: globalVariables.maximumFileSizeAllowed, // Updated property access
          type: 'pending',
        });
        modalRef.current.openModal();

      }
    }
  };

  return (
    <div className="max-w-md mx-auto overflow-hidden bg-white bg-opacity-50 b-bottom py-[15px] border-b-[1px] border-gray-100">
      <div className="flex px-5 justify-between">
        <div className="flex items-center py-1 w-[55%]">
          <span className="text-sm text-gray-700">{index + 1}. </span>
          <span className="text-sm text-gray-600 ml-1">
            {imageName !== "" ? imageName : globalVariables.uploadImage}
          </span>
        </div>
        <div className="flex items-center py-1 w-[45%]">
          <OutlineButton
            width={"w-[80%]"}
            label={globalVariables.upload}
            labelClass="text-primary text-xs"
            icon={uploadCloud}
            onClick={() => {
              inputRef.current.click();
            }}
            loading={updateImageLoading}
          />
          <input
            type="file"
            className="hidden"
            id="upload"
            ref={inputRef}
            accept={"image/png, image/jpg, image/jpeg"}
            onChange={handleFileChange}
            onClick={(event) => {
              event.target.value = null;
            }}
            hidden
          />
          <div className="ml-[6%]">
            {imageName !== "" ? (
              <div
                className="cursor-pointer"
                onClick={() => onDelete(imageKey)}
              >
                {isLoading ? (
                  <Loader customStyle={{ margin: 0 }} />
                ) : (
                  <img src={deleteIcon} alt="deleteIcon" />
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
          <PopUpMessages
            title={apiData.title}
            desc={apiData.desc}
            type={apiData.type}
            ref={modalRef}
            onCloseModal={onCloseModal}
          />
        </div>
      </div>
    </div>
  );
};
